<template>
  <div class="add-to-cart__quantity-container">
    <div
      v-if="hasTitle"
      :data-label="$t('product_form.quantity')"
      class="add-to-cart__quantity-title"
    >
      {{ $t('product_form.quantity') }}
    </div>
    <div class="add-to-cart__quantity-controls">
      <button
        class="add-to-cart__quantity-decrease"
        :disabled="quantity <= min"
        @click.prevent.stop="decreaseItemQuantity()"
      >
        <svg
          width="10"
          height="2"
          viewBox="0 0 10 2"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.416016 1.88002V0.176025H9.92002V1.88002H0.416016Z"></path>
        </svg>
      </button>
      <input
        id="quantity-updated"
        v-model.number="quantity"
        type="number"
        :readonly="isInputReadonly"
        class="add-to-cart__user-quantity"
        min="1"
      />
      <button
        class="add-to-cart__quantity-increase"
        :disabled="quantity >= max"
        @click.prevent.stop="increaseItemQuantity()"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.512207 6.88011V5.17611H5.09621V0.808105H6.89621V5.17611H11.4802V6.88011H6.89621V11.2721H5.09621V6.88011H0.512207Z"
          ></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomQuantityInput',

  props: {
    initialQuantity: Number,
    hasTitle: {
      type: Boolean,
      default: true,
    },
    isInputReadonly: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      quantity: this.initialQuantity || 1,
      min: 1,
      max: 10, // why ?
    }
  },

  watch: {
    quantity(quantity) {
      this.$emit('quantityUpdated', quantity)
    },

    initialQuantity(quantity) {
      if (typeof quantity !== 'number') return
      if (quantity === this.quantity) return
      this.quantity = quantity
    },
  },

  methods: {
    decreaseItemQuantity() {
      if (this.quantity > this.min) {
        this.quantity = --this.quantity
      }
    },
    increaseItemQuantity() {
      if (this.quantity < this.max) {
        this.quantity = ++this.quantity
      }
    },
  },
}
</script>

<style lang="scss">
.add-to-cart {
  &__quantity-container {
    margin: 10px 0px 10px 0px;
  }

  &__quantity-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 120px;

    & svg {
      vertical-align: middle;

      path {
        fill: $v4_color_orange;
      }
    }
  }

  &__quantity-title {
    font-size: 12px;
    font-weight: bold;
    color: #666;
    text-transform: uppercase;
    padding: 0 10px;
    margin: 0 0 6px 0;
    height: 14px;
    line-height: 14px;
    width: 100%;
    position: relative;

    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #ddd;
      left: 0;
      top: 50%;
      position: absolute;
    }

    &:after {
      content: attr(data-label);
      display: block;
      position: absolute;
      background-color: #fff;
      padding: 0 4px;
      top: 0;
    }
  }

  &__quantity-decrease,
  &__quantity-increase {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;
    width: 70px;
    height: 40px;
    padding: 5px !important;
    color: $v4_color_orange;
    border: 2px solid #eee;
    background-color: #fff;
    font-size: 15px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      background-color: #eee;
    }
  }

  &__quantity-decrease {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &__quantity-increase {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &__user-quantity {
    flex-grow: 1;
    text-align: center;
    border-top: 2px solid #eee !important;
    border-bottom: 2px solid #eee !important;
    background-color: #eee;
    font-size: 15px;
    width: 60px;
    height: 40px !important;
    appearance: textfield !important;
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
